import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'redux-form';
import DialogForm from '../shared/DialogForm';

export default class ConfirmPriceDialog extends React.Component {
  static propTypes = {
    dialog: PropTypes.object.isRequired,
    buckets: PropTypes.object.isRequired,
    isCRM: PropTypes.bool.isRequired,
    isSuperAdmin: PropTypes.bool.isRequired,
    initialValues: PropTypes.object.isRequired,
    formValues: PropTypes.object.isRequired,
    form: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    closeDialogFunction: PropTypes.func.isRequired,
    submitPriceFunction: PropTypes.func.isRequired,
  };

  state = { page: 1 };

  nextPage = () => {
    this.setState({
      page: this.state.page + 1,
    });
  };

  previousPage = () => {
    this.setState({
      page: this.state.page - 1,
    });
  };

  // Formats table headers
  createHeaderString = (min, max) => {
    const { isCRM } = this.props;
    let headerString = '';
    if (min === 1) {
      headerString = '<'.concat(max.toString());
    } else {
      headerString = min
        .toString()
        .concat(' - ')
        .concat(max.toString());
    }
    if (!isCRM) {
      headerString = headerString.concat('K');
    }
    return headerString;
  };

  renderFirstMessage = () => {
    const {
      buckets,
      initialValues,
      formValues,
      isCRM,
      isSuperAdmin,
      closeDialogFunction,
    } = this.props;

    // Checks to see if any buckets have actually been changed - otherwise the table won't show
    const tableUpdated = buckets.reduce((bucketLeft, bucketRight) => {
      const idString = bucketRight.id.toString();
      const floorString = idString.concat('_floor');
      return (
        bucketLeft ||
        (formValues[idString] !== initialValues[idString] ||
          formValues[floorString] !== initialValues[floorString])
      );
    }, false);

    return (
      <div className="container">
        <p>
          You are about to set a price in your price book. This will affect billing for all current
          and new orders. Please review your changes before updating.
        </p>
        <div>
          <p>
            Note:{' '}
            <i>
              Only buckets that have been modified will appear below. All other buckets will remain
              unchanged.{' '}
            </i>
          </p>
          {tableUpdated ? (
            <table className="table table-reflow table-sm">
              <thead>
                <tr>
                  <th>{isCRM ? 'Seats' : 'Records Sold'}</th>
                  <td className="double-height">{isCRM ? 'List Per Seat' : 'CPM'}</td>
                  {isSuperAdmin ? <td className="double-height">Floor</td> : null}
                </tr>
              </thead>
              <tbody>{buckets.map(this.renderFields)}</tbody>
            </table>
          ) : (
            <div className="jumbotron">
              <p>
                <strong>No changes.</strong>
                <br />
                Please return to the pricebook form and update at least one bucket before
                continuing.
              </p>
            </div>
          )}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={closeDialogFunction}>
            Continue Editing
          </button>
          {tableUpdated ? (
            <button type="button" className="btn btn-primary" onClick={this.nextPage}>
              Update Price Book
            </button>
          ) : null}
        </div>
      </div>
    );
  };

  renderFields = bucket => {
    const { isSuperAdmin, formValues, initialValues } = this.props;

    const idString = bucket.id.toString();
    const floorString = idString.concat('_floor');
    if (
      formValues[idString] !== initialValues[idString] ||
      formValues[floorString] !== initialValues[floorString]
    ) {
      // One could be not equal but the other could be equal
      const listPerSeatFieldsMatch = initialValues[idString] === formValues[idString];
      const floorFieldsMatch = initialValues[floorString] === formValues[floorString];

      return (
        <tr key={bucket.id}>
          <th>{this.createHeaderString(bucket.min, bucket.max)}</th>
          {listPerSeatFieldsMatch ? (
            <td className="double-height">${initialValues[idString]}</td>
          ) : (
            <td>
              <span className="data-old">${initialValues[idString]}</span>
              <br />
              <span className="data-updated">${formValues[idString]}</span>
            </td>
          )}
          {isSuperAdmin ? (
            <td className={floorFieldsMatch ? 'double-height' : ''}>
              {floorFieldsMatch ? (
                initialValues[floorString]
              ) : (
                <span>
                  <span className="data-old">${initialValues[floorString]}</span>
                  <br />
                  <span className="data-updated">${formValues[floorString]}</span>
                </span>
              )}
            </td>
          ) : null}
        </tr>
      );
    }

    return null;
  };

  renderSecondMessage = () => {
    const { form, closeDialogFunction, submitPriceFunction, handleSubmit } = this.props;

    return (
      <div className="container">
        <p>
          You are about to set a price in your price book. This will affect billing for all current
          and new orders. Are you sure you want to continue?
        </p>
        <div className="modal-footer">
          <Form id={form} onSubmit={handleSubmit(submitPriceFunction.bind(this))}>
            <button type="button" className="btn btn-secondary" onClick={closeDialogFunction}>
              No, Continue Editing
            </button>
            <button type="submit" className="btn btn-primary">
              Yes, Update Price Book
            </button>
          </Form>
        </div>
      </div>
    );
  };

  render() {
    const { dialog, closeDialogFunction, isCRM } = this.props;
    const { page } = this.state;

    return (
      <DialogForm
        cancelFunction={closeDialogFunction}
        cancelText="Close"
        content={page === 1 ? this.renderFirstMessage() : this.renderSecondMessage()}
        id="confirmOrderDialog"
        show={dialog.show}
        title="Confirmation"
        modalClassName={isCRM ? 'pricing-modal-crm' : 'pricing-modal-ma'}
      />
    );
  }
}
